'use client';

import * as React from 'react';
import { showReadTimeAtom } from 'app/blog/[domain]/_components/design-state';
import { useAtomValue } from 'jotai';
import { useTranslations } from 'next-intl';

export function PostDecorator({
  tag,
  readingTime,
}: {
  tag: string | undefined;
  readingTime: number;
}) {
  const t = useTranslations('Blog.Post.Header');
  const showReadTime = useAtomValue(showReadTimeAtom);
  if (!showReadTime && !tag) {
    return <></>;
  }
  return (
    <div
      className="post-decorator"
      data-has-tag={!!tag || undefined}
      data-has-read-time={showReadTime || undefined}
    >
      {tag && <PostTag tag={tag} />}
      {showReadTime && (
        <p>
          {t('ReadTime', {
            num: readingTime,
          })}
        </p>
      )}
    </div>
  );
}

type PostTagProps = { tag: string; className?: string };
export function PostTag({ tag, className }: PostTagProps): React.ReactNode {
  return (
    <p className={['post-tag', className].filter(Boolean).join(' ')}>{tag}</p>
  );
}
